import { assert } from '@/core'
import { BaseService } from './base.service'
import { ResponseWrapper } from './util'

export class AppointmentService extends BaseService {
  static get entity() {
    return 'appointments'
  }

  static async getList(parameters = {}) {
    assert.object(parameters)

    const params = { ...parameters }

    const response = await this.request({ auth: true }).get(`/hospital-staff/doctors/patient-appointments`, { params })
    // const data = {
    //   content: response.data.data,
    //   total: Number(response.headers['x-total-count'])
    // }

    return new ResponseWrapper(response, response.data.data)

  }

  static async getListV2(parameters = {}) {
    assert.object(parameters)

    const params = { ...parameters }

    const response = await this.request({ auth: true }).get(`/v2/hospital-staff/doctors/patient-appointments`, { params })
    // const data = {
    //   content: response.data.data,
    //   total: Number(response.headers['x-total-count'])
    // }

    return new ResponseWrapper(response, response.data.data)

  }

  static async getByCode(code) {
    const response = await this.request({ auth: true }).get(`/patient-appointments/code/${code}`)
    return new ResponseWrapper(response, response.data.data)
  }

  static async getById(id) {
    const response = await this.request({ auth: true }).get(`/patient-appointments?appointmentId=${id}`)
    return new ResponseWrapper(response, response.data.data)
  }

  static async getByDoctorId(parameters) {
    assert.object(parameters);

    const params = { ...parameters };

    const response = await this.request({ auth: true }).get(`/hospital-staff/patient-appointments/`, { params });

    return new ResponseWrapper(response, response.data.data)
  }

  static async approveAppointment(id, data = {}) {
    assert.string(id, { required: true })
    assert.object(data, { required: true })

    const response = await this.request({ auth: true }).patch(`assign-date/patient-appointments/${id}`, data)
    console.log("🚀 ~ AppointmentService ~ approveAppointment ~ response:", response)
    return new ResponseWrapper(response, response.data.data)
  }

  static async updateAppointment(id, data = {}) {
    assert.string(id, { required: true })
    assert.object(data, { required: true })

    const response = await this.request({ auth: true }).patch(`/patient-appointment?id=${id}`, data)
    return new ResponseWrapper(response, response)
  }
}
